import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import config from '../../config/config.json';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { setAuthState } from '../../features/auth/authSlice';
import SettingsService from '../../services/SettingsService';

export default function DiscordCallback() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (!code) {
        toast.error(t('login.errors.noCode'));
        navigate('/login');
        return;
      }

      try {
        // Exchange the code for a token
        const sessionToken = localStorage.getItem('session_token');
        const headers = sessionToken ? { 'session-token': sessionToken } : {};

        const response = await axios.post(
          config.backend_base_url + 'auth/discord/callback',
          {
            code,
          },
          { headers }
        );

        if (!response.data) {
          throw new Error('No data received from backend');
        }

        const { session_token, has_hardcore_access } = response.data;

        if (!session_token) {
          throw new Error('No session token received');
        }

        // Store the tokens
        localStorage.setItem('session_token', session_token);
        localStorage.setItem('has_hardcore_access', String(has_hardcore_access));

        // Update Redux state
        dispatch(
          setAuthState({
            isAuthenticated: true,
            sessionToken: session_token,
            hasHardcoreAccess: has_hardcore_access,
          })
        );

        // Verify the session is valid before proceeding
        try {
          await axios.get(config.backend_base_url + 'profile', {
            headers: { 'session-token': session_token },
          });

          // Only sync settings after confirming the session is valid
          const settingsService = SettingsService.getInstance();
          await settingsService.syncSettings();

          toast.success(t('login.success'));
          window.location.href = '/profile';
        } catch (error) {
          console.error('Session verification failed:', error);
          localStorage.removeItem('session_token');
          localStorage.removeItem('has_hardcore_access');
          dispatch(
            setAuthState({
              isAuthenticated: false,
              sessionToken: null,
              hasHardcoreAccess: false,
            })
          );
          toast.error(t('login.errors.failed'));
          navigate('/login');
        }
      } catch (error) {
        console.error('Error during Discord callback:', error);
        toast.error(t('login.errors.failed'));
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate, t, dispatch]);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#2d2d2d',
      }}
    >
      <div style={{ color: '#ffffff', textAlign: 'center' }}>
        <h2>{t('common.loading.fetchingData')}</h2>
        <p>Processing Discord authentication...</p>
      </div>
    </div>
  );
}
